import React from 'react'
import clsx from 'clsx'

import Image from './Image'
import Email from './Email'
import Other from './Other'

import { EMAIL_FILE_EXTENSION } from '@SonarCX/slices/extensionAPI'
import useStyles from './styles'

const MediaElementV2 = ({ media, observer, isYours, onlyImages }) => {
  const otherMedia = React.useMemo(() => media.type !== 'image', [media.type])
  const isEmail = React.useMemo(
    () => media.filename.endsWith(EMAIL_FILE_EXTENSION),
    [media.filename]
  )

  const classes = useStyles({ images: !otherMedia, otherMedia })

  return (
    <div className={clsx(classes.root)}>
      {!otherMedia && onlyImages ? (
        <Image
          media={media}
          observer={observer}
          number={1}
          className={classes.parent}
          isYours={isYours}
        />
      ) : isEmail ? (
        <Email email={media} isYours={isYours} />
      ) : (
        <Other media={media} length={media.length} isYours={isYours} />
      )}
    </div>
  )
}

export default MediaElementV2
